import { render, staticRenderFns } from "./AbkEventsBox.vue?vue&type=template&id=7fa77de8&scoped=true&"
import script from "./AbkEventsBox.vue?vue&type=script&lang=js&"
export * from "./AbkEventsBox.vue?vue&type=script&lang=js&"
import style0 from "./AbkEventsBox.vue?vue&type=style&index=0&id=7fa77de8&scoped=true&lang=scss&"
import style1 from "./AbkEventsBox.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fa77de8",
  null
  
)

export default component.exports